import type { App, Directive } from 'vue';

import { vCopy } from './copy';

export { vCopy } from './copy';
export type { CopyBindingValue } from './copy';

const directives: Record<string, Directive> = {
  copy: vCopy,
};

export function registerDirectives(app: App) {
  Object.entries(directives).forEach(([name, directive]) => {
    app.directive(name, directive);
  });
}
